import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=fb4bae58&scoped=true&"
import script from "./Information.vue?vue&type=script&lang=ts&"
export * from "./Information.vue?vue&type=script&lang=ts&"
import style0 from "./Information.vue?vue&type=style&index=0&id=fb4bae58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4bae58",
  null
  
)

export default component.exports